<template>
  <div class="aw-cooperate">
    <div class="com-sub-top">
      <div class="title container-center">
        合作伙伴
        <!-- <p class="sub-title">
          凝聚力量，与海云捷迅并肩同行，聚焦前沿科技，共筑新质生产力生态体系。
        </p> -->
      </div>
    </div>
    <div class="com-desc-box partner">
      <div class="container-center com-center">
        <p class="title">战略合作伙伴</p>
        <div class="container-center aw-partner">
          <img
            class="aw-partner-img"
            src="@/assets/about/home_partner_tcloud.jpg"
            alt=""
          />
          <img
            class="aw-partner-img"
            src="@/assets/about/home_partner_intel.jpg"
            alt=""
          />
          <img
            class="aw-partner-img"
            src="@/assets/about/home_partner_dell.jpg"
            alt=""
          />
          <img
            class="aw-partner-img"
            src="@/assets/about/home_partner_canonical.jpg"
            alt=""
          />
          <img
            class="aw-partner-img"
            src="@/assets/about/home_partner_sobey.jpg"
            alt=""
          />
          <img
            class="aw-partner-img"
            src="@/assets/about/home_partner_lenovo.jpg"
            alt=""
          />
          <img
            class="aw-partner-img"
            src="@/assets/about/home_partner_putian.jpg"
            alt=""
          />
          <img
            class="aw-partner-img"
            src="@/assets/about/home_partner_ruijie.jpg"
            alt=""
          />
          <img
            class="aw-partner-img"
            src="@/assets/about/home_partner_panath.jpg"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="com-desc-box">
      <div class="container-center com-center">
        <p class="title">国产化合作伙伴</p>
        <ul class="strategy-list">
          <li>
            <span class="circle"></span> <span class="name">CPU合作伙伴</span>
            <img src="@/assets/about/partner_localization_01.png" alt="" />
          </li>
          <li>
            <span class="circle"></span> <span class="name">GPU合作伙伴</span>
            <img src="@/assets/about/partner_localization_02.png" alt="" />
          </li>
          <li>
            <span class="circle"></span> <span class="name">整机合作伙伴</span>
            <img src="@/assets/about/partner_localization_03.png" alt="" />
          </li>
          <li>
            <span class="circle"></span> <span class="name">操作系统合作伙伴</span>
            <img src="@/assets/about/partner_localization_04.png" alt="" />
          </li>
        </ul>
      </div>
    </div>

    <div class="com-desc-box partner-coo-box">
      <div class="container-center com-center advantage">
        <p class="title">合作伙伴展示</p>
        <ul class="partner-coo">
          <li>
            <img src="@/assets/about/partner_cooperation_01.jpg" alt="" />
            <h5>东软集团股份有限公司</h5>
            <p class="desc">东软集团是中国领先的IT解决方案与服务供应商，上市企业，股票代码600718。公司成立于1991年，前身为东北大学下属的沈阳东大开发软件系统股份有限公司和沈阳东大阿尔派软件有限公司。</p>
          </li>
          <li>
            <img src="@/assets/about/partner_cooperation_02.jpg" alt="" />
            <h5>深圳脑立方科技有限公司</h5>
            <p class="desc">深圳市脑立方科技有限公司是一家以软件服务、应用开发、架构整合、系统集成于一体的综合性高科技企业，公司战略定位在企业级私有云计算平台的构建和运营。</p>
          </li>
          <li>
            <img src="@/assets/about/partner_cooperation_03.jpg" alt="" />
            <h5>贵州高新翼云科技有限公司</h5>
            <p class="desc">公司成立于2014年3月，位于贵阳国家高新区中关村科技园，由贵阳国家高新区下属企业与广东省国资委下属企业共同投资组建，注册资金5000万，初期投资3亿。</p>
          </li>
          <li>
            <img src="@/assets/about/partner_cooperation_04.jpg" alt="" />
            <h5>鹏博士</h5>
            <p class="desc">鹏博士 （股票代码：600804）注册资本为13亿元，是一家以新一代光通信技术为基础，宽带互联网接入和应用(ISP)、数据中心（IDC）为主营业务的高科技企业集团</p>
          </li>
          <li>
            <img src="@/assets/about/partner_cooperation_05.jpg" alt="" />
            <h5>北京首都在线科技股份有限公司</h5>
            <p class="desc">北京首都在线科技股份有限公司（下称首都在线）是中国早期的IDC服务商之一，已经发展成为以北京为总部，上海、武汉等地设有子公司的全国性专业化IDC运营商和云计算服务提供商。</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {},
};
</script>